import { useQuery } from '@tanstack/react-query';

import masterServicesApi from '../../../apis/master-services';
import useLocationQuery from '../../../hooks/useQuery';

import ServiceConditionsTable from './ServiceConditionsTable';
import { usePersistedTotal } from '../../../hooks/useTablePagination';

export default function ServiceConditionsContainer() {
  const { query, changeLocationQuery } = useLocationQuery();
  const { page = 0, limit = 10 } = query;

  const { data: result, isLoading } = useQuery({
    queryKey: ['service-conditions', page, limit],
    queryFn: ({ queryKey }) => masterServicesApi.getServiceConditions({ page: queryKey[1], limit: queryKey[2] }),
    meta: { errorMessage: 'Failed to fetch service conditions' },
    refetchOnWindowFocus: false,
  });

  const total = usePersistedTotal(result?.pagination.total);

  return (<div>
    <ServiceConditionsTable
      conditions={result?.data}
      page={Number(page)}
      rowsPerPage={Number(limit)}
      rowsPerPageOptions={[5, 10, 20, 50]}
      total={total}
      isLoading={isLoading}
      onRowsPerPageChange={(e) => changeLocationQuery({ ...query, limit: e.target.value })}
      onPageChange={(_, newPage) => changeLocationQuery({ ...query, page: newPage })}
    />
  </div>);
};
